import { render, staticRenderFns } from "./UserDetailContainer.vue?vue&type=template&id=4e17a9e0&"
import script from "./UserDetailContainer.vue?vue&type=script&lang=js&"
export * from "./UserDetailContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports